import { render, staticRenderFns } from "./video.vue?vue&type=template&id=5152263e&scoped=true"
import script from "./video.vue?vue&type=script&lang=js"
export * from "./video.vue?vue&type=script&lang=js"
import style0 from "./video.vue?vue&type=style&index=0&id=5152263e&prod&lang=css"
import style1 from "./video.vue?vue&type=style&index=1&id=5152263e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5152263e",
  null
  
)

export default component.exports